
import { Component, Getter, namespace, Vue } from 'bits/vue'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from 'library/v4/components/OzContainedButton.vue'
import type { Cid, Post } from 'types'

@Component({
  components: {
    OzContainedButton,
  },
})
export default class SurfacePanelPostExpandedApprovalBanner extends Vue {
  OzContainedButtonSizePreset = OzContainedButtonSizePreset
  OzContainedButtonColorScheme = OzContainedButtonColorScheme

  @Getter canIModerate!: boolean
  @namespace('postAction').Getter expandedPost!: Post
  @namespace('postAction').Action confirmDeletePost!: (payload: { postCid: Cid }) => void
  @namespace('post').Action approvePost!: (payload: { postCid: Cid }) => void
}
